<template>
  <div class="finance-management">
    <el-card>
      <!-- 搜索表单 -->
      <el-form :model="searchForm" inline size="small" @submit.native.prevent>
        <el-form-item label="时间范围：">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="handleSearch"
          ></el-date-picker>
        </el-form-item>
        
        <el-form-item label="技师姓名：">
          <el-input
            v-model="searchForm.technicianName"
            placeholder="请输入技师姓名"
            style="width: 150px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="交易类型：">
          <el-select v-model="searchForm.type" clearable placeholder="请选择" style="width: 120px" @change="handleSearch">
            <el-option label="订单收入" value="income"></el-option>
            <el-option label="提现" value="withdraw"></el-option>
            <el-option label="佣金" value="commission"></el-option>
            <el-option label="退款" value="refund"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="success" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
      
  
      
    
      
      <!-- 每日统计表格 -->
      <div>
       
        <el-table :data="dayStatsList" v-loading="loading" style="width: 100%">
          <el-table-column prop="statsDate" label="统计日期" width="120">
            <template slot-scope="scope">
              {{ scope.row.statsDate || scope.row.createTime }}
            </template>
          </el-table-column>
          
          <el-table-column prop="payAmount" label="付款金额" width="120">
            <template slot-scope="scope">
              ¥{{ parseFloat(scope.row.payAmount || 0).toFixed(2) }}
            </template>
          </el-table-column>
          
          <el-table-column prop="actualAmount" label="实际金额" width="120">
            <template slot-scope="scope">
              ¥{{ parseFloat(scope.row.actualAmount || 0).toFixed(2) }}
            </template>
          </el-table-column>
          
          <el-table-column prop="refundAmount" label="退款金额" width="120">
            <template slot-scope="scope">
              ¥{{ parseFloat(scope.row.refundAmount || 0).toFixed(2) }}
            </template>
          </el-table-column>
          
          <el-table-column prop="orderUserCount" label="下单人数" width="100"></el-table-column>
          
          <el-table-column prop="payUserCount" label="付款人数" width="100"></el-table-column>
          
          <el-table-column prop="actualPayUserCount" label="实际付款人数" width="120"></el-table-column>
          
          <el-table-column prop="refundUserCount" label="退款人数" width="100"></el-table-column>
          
          <el-table-column prop="refundRate" label="退款率">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.refundRate || 0).toFixed(2) }}%
            </template>
          </el-table-column>
          
          <!-- <el-table-column prop="statsHour" label="统计小时" width="100"></el-table-column> -->
        </el-table>
        
        <!-- 分页 -->
        <el-pagination
          @size-change="handleDayStatsSizeChange"
          @current-change="handleDayStatsCurrentChange"
          :current-page="dayStatsPagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="dayStatsPagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dayStatsPagination.total"
          style="margin-top: 20px; text-align: right"
        >
        </el-pagination>
      </div>
    </el-card>
    
    <!-- 交易详情对话框 -->
    <el-dialog title="交易详情" :visible.sync="detailVisible" width="600px">
      <div v-if="currentTransaction" class="transaction-detail">
        <div class="detail-section">
          <h4>交易信息</h4>
          <div class="detail-item">
            <span class="label">交易ID：</span>
            <span>{{ currentTransaction.id }}</span>
          </div>
          <div class="detail-item">
            <span class="label">交易类型：</span>
            <el-tag :type="getTypeColor(currentTransaction.type)">{{ getTypeText(currentTransaction.type) }}</el-tag>
          </div>
          <div class="detail-item">
            <span class="label">交易金额：</span>
            <span :style="{ color: currentTransaction.amount > 0 ? '#67c23a' : '#f56c6c', fontWeight: 'bold' }">
              {{ currentTransaction.amount > 0 ? '+' : '' }}¥{{ Math.abs(currentTransaction.amount) }}
            </span>
          </div>
          <div class="detail-item">
            <span class="label">交易状态：</span>
            <el-tag :type="currentTransaction.status === 'success' ? 'success' : currentTransaction.status === 'pending' ? 'warning' : 'danger'">
              {{ getStatusText(currentTransaction.status) }}
            </el-tag>
          </div>
          <div class="detail-item">
            <span class="label">交易时间：</span>
            <span>{{ currentTransaction.createTime }}</span>
          </div>
        </div>
        
        <div v-if="currentTransaction.technician" class="detail-section">
          <h4>技师信息</h4>
          <div class="detail-item">
            <span class="label">技师姓名：</span>
            <span>{{ currentTransaction.technician.name }}</span>
          </div>
          <div class="detail-item">
            <span class="label">联系电话：</span>
            <span>{{ currentTransaction.technician.phone }}</span>
          </div>
        </div>
        
        <div v-if="currentTransaction.orderNo" class="detail-section">
          <h4>关联订单</h4>
          <div class="detail-item">
            <span class="label">订单编号：</span>
            <span style="color: #409EFF; cursor: pointer" @click="viewOrder(currentTransaction.orderNo)">
              {{ currentTransaction.orderNo }}
            </span>
          </div>
        </div>
        
        <div class="detail-section">
          <h4>交易描述</h4>
          <p>{{ currentTransaction.description }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getFinanceList, getFinanceDetail, getFinanceStatistics, exportFinanceData, getMerchantDayStats } from '@/api/finance'

export default {
  name: 'FinanceManagement',
  data() {
    return {
      loading: false,
      searchForm: {
        dateRange: [],
        technicianName: '',
        type: ''
      },
      tableData: [],
      pagination: {
        page: 1,
        limit: 20,
        total: 0
      },
      statistics: {
        totalIncome: '0.00',
        totalOrders: 0,
        totalRefund: '0.00',
        totalUsers: 0,
        avgOrderValue: '0.00'
      },
      dayStatsList: [],
      dayStatsPagination: {
        page: 1,
        limit: 20,
        total: 0
      },
      detailVisible: false,
      currentTransaction: null
    }
  },
  created() {
    // this.loadData()
    this.loadStatistics()
    this.initCharts()
  },
  methods: {
    // 加载数据
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
          ...this.searchForm
        }
        const response = await getFinanceList(params)
        this.tableData = response.data.list || []
        this.pagination.total = response.data.total || 0
      } catch (error) {
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    
    // 加载统计数据
    async loadStatistics() {
      try {
        const params = {
          page: this.dayStatsPagination.page,
          limit: this.dayStatsPagination.limit
        }
        const response = await getMerchantDayStats(params)
        
        if (response.code === 200) {
          const statsData = response.data || {}
          this.statistics = this.processStatsData(statsData)
          this.dayStatsList = statsData.list || []
          this.dayStatsPagination.total = statsData.total || 0
        } else {
          this.$message.error(response.message || '获取统计数据失败')
        }
      } catch (error) {
        console.error('加载统计数据失败', error)
        this.$message.error('加载统计数据失败')
      }
    },

    // 处理统计数据
    processStatsData(data) {
      const list = data.list || []
      
      // 计算汇总数据，确保类型转换正确
      const totalIncome = list.reduce((sum, item) => sum + parseFloat(item.payAmount || 0), 0)
      const totalOrders = list.reduce((sum, item) => sum + parseInt(item.orderUserCount || 0), 0)
      const totalRefund = list.reduce((sum, item) => sum + parseFloat(item.refundAmount || 0), 0)
      const totalUsers = list.reduce((sum, item) => sum + parseInt(item.payUserCount || 0), 0)
      
      return {
        totalIncome: totalIncome.toFixed(2),
        totalOrders,
        totalRefund: totalRefund.toFixed(2),
        totalUsers,
        avgOrderValue: totalOrders > 0 ? (totalIncome / totalOrders).toFixed(2) : '0.00'
      }
    },
    
    // 初始化图表
    initCharts() {
      // 这里可以集成 ECharts 或其他图表库
      // 暂时显示占位内容
      setTimeout(() => {
        const incomeChart = document.getElementById('incomeChart')
        const typeChart = document.getElementById('typeChart')
        
        if (incomeChart) {
          incomeChart.innerHTML = '<div style="text-align: center; line-height: 300px; color: #999;">收入趋势图表</div>'
        }
        
        if (typeChart) {
          typeChart.innerHTML = '<div style="text-align: center; line-height: 300px; color: #999;">交易类型分布图表</div>'
        }
      }, 100)
    },
    
    // 搜索
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        dateRange: [],
        technicianName: '',
        type: ''
      }
      this.handleSearch()
    },
    
    // 导出数据
    async handleExport() {
      try {
        const params = { ...this.searchForm }
        await exportFinanceData(params)
        this.$message.success('导出成功')
      } catch (error) {
        this.$message.error('导出失败')
      }
    },
    
    // 查看详情
    async handleViewDetail(row) {
      try {
        const response = await getFinanceDetail(row.id)
        this.currentTransaction = response.data
        this.detailVisible = true
      } catch (error) {
        this.$message.error('获取交易详情失败')
      }
    },
    
    // 查看订单
    viewOrder(orderNo) {
      this.$router.push({ path: '/orders', query: { orderNo } })
    },
    
    // 获取交易类型颜色
    getTypeColor(type) {
      const colorMap = {
        income: 'success',
        withdraw: 'warning',
        commission: 'primary',
        refund: 'danger'
      }
      return colorMap[type] || 'info'
    },
    
    // 获取交易类型文本
    getTypeText(type) {
      const textMap = {
        income: '订单收入',
        withdraw: '提现',
        commission: '佣金',
        refund: '退款'
      }
      return textMap[type] || '未知'
    },
    
    // 获取状态文本
    getStatusText(status) {
      const textMap = {
        success: '成功',
        pending: '处理中',
        failed: '失败'
      }
      return textMap[status] || '未知'
    },
    
    // 分页大小变更
    handleSizeChange(val) {
      this.pagination.limit = val
      this.pagination.page = 1
      this.loadData()
    },
    
    // 当前页变更
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadData()
    },

    // 每日统计分页大小变更
    handleDayStatsSizeChange(val) {
      this.dayStatsPagination.limit = val
      this.dayStatsPagination.page = 1
      this.loadStatistics()
    },
    
    // 每日统计当前页变更
    handleDayStatsCurrentChange(val) {
      this.dayStatsPagination.page = val
      this.loadStatistics()
    }
  }
}
</script>

<style scoped>
.finance-management {
  padding: 20px;
}

.stat-card {
  text-align: center;
}

.stat-item {
  padding: 10px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
}

.stat-label {
  font-size: 14px;
  color: #666;
  margin-top: 5px;
}

.transaction-detail {
  padding: 20px;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-section h4 {
  margin-bottom: 15px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}

.detail-item {
  margin-bottom: 10px;
  display: flex;
}

.detail-item .label {
  width: 100px;
  color: #666;
  flex-shrink: 0;
}
</style>
